import { parseAxiosError } from "@tfg/ui"
import i18next from "i18next"

import { showErrorNotification } from "~/utils/showErrorNotification"

type Props = {
  error: Error
  defaultMessage?: string
  showNotification?: boolean
  notificationTitle?: string
  notificationMessage?: string
}

export const showAxiosError = ({
  error,
  defaultMessage,
  showNotification = false,
  notificationTitle,
  notificationMessage,
}: Props) => {
  const axiosErrorMessage = parseAxiosError(error)
  let errorMessage = defaultMessage ?? i18next.t("error.default")

  if (axiosErrorMessage) {
    errorMessage = axiosErrorMessage
  }

  if (notificationMessage) {
    errorMessage = `${notificationMessage}: ${errorMessage}`
  }

  if (showNotification) {
    showErrorNotification({
      title: notificationTitle,
      message: errorMessage,
    })
  }
  return error.message
}
